import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { PolicyLineDialog } from "./PolicyLineDialog";
import { usePolicyLines } from "@/hooks/usePolicyLines";
import { usePolicyLineOperations } from "./hooks/usePolicyLineOperations";
import { PolicyLineTable } from "./components/PolicyLineTable";
import { PolicyLine } from "./types";

export const PolicyLinesContainer = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedPolicyLine, setSelectedPolicyLine] = useState<PolicyLine | null>(null);
  
  const { data: policyLines, updateOrder } = usePolicyLines();
  const { deletePolicyLine } = usePolicyLineOperations();

  const handleEdit = (policyLine: PolicyLine) => {
    setSelectedPolicyLine(policyLine);
    setIsDialogOpen(true);
  };

  const handleDelete = async (id: string) => {
    await deletePolicyLine(id);
  };

  const handleReorder = async (reorderedItems: PolicyLine[]) => {
    await updateOrder.mutateAsync(reorderedItems);
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold">Manage Policy Lines</h2>
        <Button onClick={() => setIsDialogOpen(true)} className="text-white">
          <Plus className="w-4 h-4 mr-2" />
          Add Policy Line
        </Button>
      </div>

      <PolicyLineTable
        policyLines={policyLines}
        onEdit={handleEdit}
        onDelete={handleDelete}
        onReorder={handleReorder}
      />

      <PolicyLineDialog
        isOpen={isDialogOpen}
        onClose={() => {
          setIsDialogOpen(false);
          setSelectedPolicyLine(null);
        }}
        onOpenChange={setIsDialogOpen}
        selectedPolicyLine={selectedPolicyLine}
      />
    </div>
  );
};